(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-private-parties-block"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.pp-block-image-wrapper--blur-up').forEach(function(wrapper) {
      var img = wrapper.querySelector('.pp-block-image-img');
      if (!img) return;
      function markLoaded() { wrapper.classList.add('is-loaded'); }
      if (img.complete) markLoaded();
      else img.addEventListener('load', markLoaded);
    });

    var modal = document.getElementById('popup-private-events-form');
    if (!modal) return;
    function openModal(blockLabel) {
      modal.classList.remove('mfp-hide');
      modal.classList.add('is-open');
      document.querySelector('html').classList.add('ts-is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';      
      document.addEventListener('keydown', onKeydown);
      var closeBtn = modal.querySelector('.tripleseat-modal__close');
      if (closeBtn) closeBtn.focus();
      if (blockLabel && typeof blockLabel === 'string') {
        var el = modal.querySelector('#lead_additional_information') || modal.querySelector('tr.row_additional_information');
        var field = el && (el.id === 'lead_additional_information' && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA')) ? el : (el ? el.querySelector('input, textarea') : null);
        if (field) field.value = blockLabel ? 'Dining Room: ' + blockLabel : '';
      }
    }
    function closeModal() {
      modal.classList.add('mfp-hide');
      modal.classList.remove('is-open');      
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.querySelector('html').classList.remove('ts-is-open');
      document.removeEventListener('keydown', onKeydown);
    }
    function onKeydown(e) {
      if (e.key === 'Escape') closeModal();
    }
    document.body.addEventListener('click', function(e) {
      var target = e.target instanceof Element ? e.target : null;
      var btn = target && target.closest('.tripleseat_form_popup');
      if (btn) {
        e.preventDefault();
        var wrapper = btn.closest('.pp-block-wrapper');
        var h3 = wrapper ? wrapper.querySelector('.pp-block-content h3') : null;
        var blockLabel = (h3 && h3.textContent) ? h3.textContent.trim() : '';
        openModal(blockLabel);
      }
    });
    modal.querySelectorAll('[data-tripleseat-close]').forEach(function(el) {
      el.addEventListener('click', closeModal);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-header-group"] && !Shopify.designMode) return;
  try {
    
  /**
   * MPHeaderSticky – Refactored
   *
   * State-machine approach with 5 states:
   *   INACTIVE  → header in normal document flow
   *   ENTERING  → header just became fixed, animating in
   *   VISIBLE   → sticky header is visible (scrolling up / at threshold)
   *   HIDDEN    → sticky header is off-screen (scrolling down)
   *   EXITING   → transitioning back to INACTIVE (desktop only)
   *
   * Key improvements over original:
   *   1. Single source of truth via this.state — no conflicting classList checks
   *   2. Resize recalculates mobile/desktop breakpoint + offset (was stale before)
   *   3. Activate/deactivate use a single rAF + transitionend (no double-rAF + setTimeout hacks)
   *   4. destroy() method for clean teardown on Shopify section reload
   *   5. Scroll direction uses a dead-zone to ignore micro-jitter (2px threshold)
   *   6. Mobile: always sticky from load, hide/show on scroll direction
   *   7. Desktop: sticky after offset, show only on scroll-up
   */

  const STATES = {
    INACTIVE: 'INACTIVE',
    ENTERING: 'ENTERING',
    VISIBLE: 'VISIBLE',
    HIDDEN: 'HIDDEN',
    EXITING: 'EXITING',
  };

  const MOBILE_BREAKPOINT = 1023;
  const SCROLL_JITTER_THRESHOLD = 2; // ignore scroll deltas smaller than this
  const MIN_DOWN_PX_TO_HIDE = 80; // desktop: only hide after scrolling down this many px (avoids hide on release jitter)
  const TRANSITION_DURATION_FALLBACK = 300; // ms – safety net if transitionend never fires

  class MPHeaderSticky {
    constructor(header) {
      this.header = header;
      this.spacer = null;
      this.state = STATES.INACTIVE;
      this.headerHeight = 0;
      this.lastScrollY = window.scrollY;
      this.baseOffset = parseInt(header.getAttribute('data-sticky-offset') || '100', 10) || 100;
      this.offset = this.baseOffset;
      this.isMobile = false;
      this.scrollYWhenVisible = 0; // used so we only hide after scrolling down MIN_DOWN_PX_TO_HIDE
      this.raf = null;
      this.exitFallbackTimer = null;
      this._boundOnScroll = this._onScroll.bind(this);
      this._boundOnResize = this._onResize.bind(this);
      this._boundExitEnd = this._onExitTransitionEnd.bind(this);

      this._init();
    }

    /* ------------------------------------------------------------------ */
    /*  Lifecycle                                                          */
    /* ------------------------------------------------------------------ */

    _init() {
      if (!this.header || this.header.getAttribute('data-sticky-header') !== 'true') return;

      this._recalcBreakpoint();

      window.addEventListener('scroll', this._boundOnScroll, { passive: true });
      window.addEventListener('resize', this._boundOnResize, { passive: true });

      // Mobile: activate immediately so the header is always fixed
      if (this.isMobile) {
        this._activate();
      }
      // Desktop: evaluate current scroll position (page may have loaded mid-scroll)
      this._evaluateScroll();
    }

    destroy() {
      window.removeEventListener('scroll', this._boundOnScroll);
      window.removeEventListener('resize', this._boundOnResize);
      if (this.raf) cancelAnimationFrame(this.raf);
      clearTimeout(this.exitFallbackTimer);
      this._removeSpacer();
      this._clearClasses();
      this.state = STATES.INACTIVE;
    }

    /* ------------------------------------------------------------------ */
    /*  Scroll handling                                                    */
    /* ------------------------------------------------------------------ */

    _onScroll() {
      if (this.raf) return; // already scheduled
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        this._evaluateScroll();
      });
    }

    _evaluateScroll() {
      const scrollY = window.scrollY;
      const delta = scrollY - this.lastScrollY;

      // Ignore micro-jitter (touch inertia, sub-pixel stuff)
      const direction =
        Math.abs(delta) < SCROLL_JITTER_THRESHOLD
          ? null // no meaningful change
          : delta > 0
            ? 'down'
            : 'up';

      // Only update lastScrollY when the delta was meaningful
      if (direction) this.lastScrollY = scrollY;

      switch (this.state) {
        case STATES.INACTIVE:
          this._handleInactive(scrollY, direction);
          break;
        case STATES.ENTERING:
          // Let the enter animation finish — don't react to scroll yet
          break;
        case STATES.VISIBLE:
        case STATES.HIDDEN:
          this._handleSticky(scrollY, direction);
          break;
        case STATES.EXITING:
          // Mid-exit: if user scrolls back down past offset, cancel the exit
          if (scrollY >= this.offset) {
            this._cancelExit();
            this._setState(STATES.VISIBLE);
          }
          break;
      }
    }

    /** When header is in normal flow */
    _handleInactive(scrollY, direction) {
      if (scrollY >= this.offset) {
        this._activate();

        // Desktop: if first activation happens while scrolling down, start hidden
        if (!this.isMobile && direction === 'down') {
          // _activate sets state to ENTERING → once enter finishes it becomes VISIBLE.
          // We override to HIDDEN after the enter completes (handled inside _onEnterDone).
          this._startHiddenAfterEnter = true;
        }
      }
    }

    /** When header is sticky (VISIBLE or HIDDEN) */
    _handleSticky(scrollY, direction) {
      // Scrolled back above the threshold → deactivate (desktop only). Always instant so no glitch at top.
      if (scrollY <= 0 || (!this.isMobile && scrollY < this.offset)) {
        if (this.isMobile) {
          // Mobile: always stay sticky, just make sure it's visible at the top
          this._setState(STATES.VISIBLE);
        } else {
          // Desktop: snap back to normal flow immediately when above offset (no exit animation)
          this._deactivate(true);
        }
        return;
      }

      if (!direction) return; // no meaningful scroll change

      if (direction === 'down') {
        if (this.state !== STATES.HIDDEN) {
          // Mobile: only hide after an extra buffer to avoid flicker on small swipes
          if (this.isMobile && scrollY < this.offset + 250) return;
          // Desktop: only hide after user has scrolled down a meaningful amount (avoids hide on mouse release jitter)
          if (!this.isMobile && (scrollY - this.scrollYWhenVisible) < MIN_DOWN_PX_TO_HIDE) return;
          this._setState(STATES.HIDDEN);
        }
      } else {
        // scrolling up → reveal and remember position so we require MIN_DOWN_PX_TO_HIDE before hiding again
        if (this.state !== STATES.VISIBLE) {
          this.scrollYWhenVisible = scrollY;
          this._setState(STATES.VISIBLE);
        }
      }
    }

    /* ------------------------------------------------------------------ */
    /*  State transitions                                                  */
    /* ------------------------------------------------------------------ */

    _setState(newState) {
      if (this.state === newState) return;
      this.state = newState;
      this._syncClasses();
    }

    _syncClasses() {
      const cl = this.header.classList;

      // Always present when sticky is engaged
      const isActive = [STATES.ENTERING, STATES.VISIBLE, STATES.HIDDEN, STATES.EXITING].includes(this.state);
      cl.toggle('mp-header--sticky-active', isActive);
      cl.toggle('mp-header--sticky-entering', this.state === STATES.ENTERING);
      cl.toggle('mp-header--sticky-hidden', this.state === STATES.HIDDEN);
      cl.toggle('mp-header--sticky-exiting', this.state === STATES.EXITING);
    }

    _clearClasses() {
      this.header.classList.remove(
        'mp-header--sticky-active',
        'mp-header--sticky-entering',
        'mp-header--sticky-hidden',
        'mp-header--sticky-exiting'
      );
    }

    /* ------------------------------------------------------------------ */
    /*  Activate (normal → sticky)                                        */
    /* ------------------------------------------------------------------ */

    _activate() {
      if (this.state !== STATES.INACTIVE) return;

      this._ensureSpacer();
      this._setState(STATES.ENTERING);

      // Measure height *after* the header is position:fixed
      // We need one frame for the browser to apply the fixed layout
      requestAnimationFrame(() => {
        this.headerHeight = this.header.offsetHeight;
        this.spacer.style.height = this.headerHeight + 'px';

        // Remove the entering class on the *next* frame so the transition plays
        requestAnimationFrame(() => {
          this._onEnterDone();
        });
      });
    }

    _onEnterDone() {
      if (this.state !== STATES.ENTERING) return;

      if (this._startHiddenAfterEnter) {
        this._startHiddenAfterEnter = false;
        this._setState(STATES.HIDDEN);
      } else {
        this.scrollYWhenVisible = window.scrollY;
        this._setState(STATES.VISIBLE);
      }
    }

    /* ------------------------------------------------------------------ */
    /*  Deactivate (sticky → normal) – desktop only                       */
    /* ------------------------------------------------------------------ */

    /**
     * @param {boolean} instant – true = skip animation (used when back at page top)
     */
    _deactivate(instant = false) {
      if (this.state === STATES.INACTIVE || this.state === STATES.EXITING) return;

      // When we're back near the top the static header is already in view,
      // so animating out causes a visible flash. Just snap back immediately.
      if (instant) {
        clearTimeout(this.exitFallbackTimer);
        if (this.spacer) this.spacer.removeEventListener('transitionend', this._boundExitEnd);
        this._removeSpacer();
        this._clearClasses();
        this.state = STATES.INACTIVE;
        return;
      }

      this._setState(STATES.EXITING);

      // Collapse the spacer to trigger its CSS transition
      if (this.spacer) {
        this.spacer.style.height = '0px';
        this.spacer.addEventListener('transitionend', this._boundExitEnd, { once: true });
      }

      // Fallback in case transitionend doesn't fire (display:none, etc.)
      this.exitFallbackTimer = setTimeout(this._boundExitEnd, TRANSITION_DURATION_FALLBACK);
    }

    _onExitTransitionEnd() {
      if (this.state !== STATES.EXITING) return;

      clearTimeout(this.exitFallbackTimer);
      if (this.spacer) {
        this.spacer.removeEventListener('transitionend', this._boundExitEnd);
      }
      this._removeSpacer();
      this._setState(STATES.INACTIVE);
    }

    _cancelExit() {
      if (this.state !== STATES.EXITING) return;

      clearTimeout(this.exitFallbackTimer);
      if (this.spacer) {
        this.spacer.removeEventListener('transitionend', this._boundExitEnd);
        this.spacer.style.height = this.headerHeight + 'px';
      }
      // State will be set by the caller
    }

    /* ------------------------------------------------------------------ */
    /*  Spacer management                                                  */
    /* ------------------------------------------------------------------ */

    _ensureSpacer() {
      if (this.spacer) return;
      this.spacer = document.createElement('div');
      this.spacer.className = 'mp-header-sticky-spacer';
      this.spacer.setAttribute('aria-hidden', 'true');
      this.spacer.style.height = '0px';
      this.header.parentNode.insertBefore(this.spacer, this.header);
    }

    _removeSpacer() {
      if (this.spacer && this.spacer.parentNode) {
        this.spacer.parentNode.removeChild(this.spacer);
      }
      this.spacer = null;
    }

    _updateSpacerHeight() {
      if (this.state === STATES.EXITING || this.state === STATES.INACTIVE) return;
      if (!this.spacer) return;

      const h = this.header.offsetHeight;
      if (h > 0 && h !== this.headerHeight) {
        this.headerHeight = h;
        this.spacer.style.height = h + 'px';
      }
    }

    /* ------------------------------------------------------------------ */
    /*  Resize handling                                                    */
    /* ------------------------------------------------------------------ */

    _onResize() {
      const wasMobile = this.isMobile;
      this._recalcBreakpoint();

      // Breakpoint changed: tear down and reinitialize cleanly
      if (wasMobile !== this.isMobile) {
        this._teardownForBreakpointChange();
        if (this.isMobile) {
          this._activate();
        } else {
          this._evaluateScroll();
        }
        return;
      }

      // Same breakpoint — just update spacer in case header height changed
      this._updateSpacerHeight();
    }

    _recalcBreakpoint() {
      this.isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

      if (this.isMobile) {
        this.offset = this.baseOffset;
      } else {
        // Desktop: trigger between baseOffset and viewport midpoint
        this.offset = Math.round((this.baseOffset + window.innerHeight) / 2);
      }
    }

    /** Reset state cleanly when crossing the mobile/desktop breakpoint */
    _teardownForBreakpointChange() {
      clearTimeout(this.exitFallbackTimer);
      if (this.spacer) {
        this.spacer.removeEventListener('transitionend', this._boundExitEnd);
      }
      this._removeSpacer();
      this._clearClasses();
      this.state = STATES.INACTIVE;
      this.lastScrollY = window.scrollY;
    }
  }


  /* ===================================================================== */
  /*  MPHeaderMenu (mobile hamburger) – cleaned up, no logic changes       */
  /* ===================================================================== */

  class MPHeaderMenu {
    constructor() {
      this.hamburger = document.querySelector('.mp-header__hamburger');
      this.mobileMenu = document.querySelector('.mp-header__mobile-menu');
      this.mobileMenuLinks = document.querySelectorAll('.mp-header__mobile-menu-link');

      if (this.hamburger && this.mobileMenu) this._init();
    }

    _init() {
      this.hamburger.addEventListener('click', () => this._toggle());

      this.mobileMenuLinks.forEach((link) =>
        link.addEventListener('click', () => this._close())
      );

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this._isOpen()) this._close();
      });

      window.addEventListener('resize', () => {
        if (window.innerWidth > MOBILE_BREAKPOINT && this._isOpen()) this._close();
      });

      // Prevent background scroll-through on touch
      this.mobileMenu.addEventListener(
        'touchmove',
        (e) => { if (e.target === this.mobileMenu) e.preventDefault(); },
        { passive: false }
      );
    }

    _isOpen() {
      return this.mobileMenu.classList.contains('active');
    }

    _toggle() {
      this._isOpen() ? this._close() : this._open();
    }

    _open() {
      this.mobileMenu.classList.add('active');
      this.hamburger.classList.add('active');
      this.hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    _close() {
      this.mobileMenu.classList.remove('active');
      this.hamburger.classList.remove('active');
      this.hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  }


  /* ===================================================================== */
  /*  Bootstrap                                                            */
  /* ===================================================================== */

  // Track instances so we can destroy on section reload
  let _stickyInstance = null;
  let _menuInstance = null;

  function initMPHeader() {
    // Destroy previous instances to prevent duplicate listeners
    if (_stickyInstance) _stickyInstance.destroy();

    const header = document.querySelector('.mp-header');
    if (header) _stickyInstance = new MPHeaderSticky(header);
    _menuInstance = new MPHeaderMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMPHeader);
  } else {
    initMPHeader();
  }

  // Shopify theme editor: re-init on section load
  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (target.matches('.mp-header') || target.querySelector('.mp-header')) {
      initMPHeader();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
